export const ROUTES = {
  MAIN: "/",
  LOGIN: "/login",
  SURVEY: "/survey",
  SIGN_UP: "/signup",
  EXAM: "/exam",
  MY_PAGE: "/mypage",
  SURVEY_MANAGE: "/mypage/survey",
  FEEDBACK: "/feedback",
};
